function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "dashboarda",
  d: "M13 .438c-7.166 0-13 5.833-13 13 0 2.855.929 5.499 2.497 7.647l1.757-1.47a10.688 10.688 0 0 1-1.96-6.177C2.294 7.51 7.074 2.732 13 2.732c5.926 0 10.706 4.78 10.706 10.706 0 2.303-.73 4.434-1.96 6.177l1.757 1.47A12.928 12.928 0 0 0 26 13.437c0-7.166-5.834-13-13-13zm6.763 9.295l-8.113 5.413a1.907 1.907 0 0 0 0 2.7 1.907 1.907 0 0 0 2.7 0l5.413-8.113z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "dashboardb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dashboarda"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#dashboarda"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#dashboardb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-2h26v26H0z"
})));

const SvgBmDashboard = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBmDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bm-dashboard.df88fb4d.svg";
export { ForwardRef as ReactComponent };